export type ZohoState = {
    zohoId: string;
};

export const zohoDefaultState: ZohoState = {
    zohoId: null,
};
